import { render, staticRenderFns } from "./RejectedRepairPartTable.vue?vue&type=template&id=028d6a2d&scoped=true&"
import script from "./RejectedRepairPartTable.vue?vue&type=script&lang=js&"
export * from "./RejectedRepairPartTable.vue?vue&type=script&lang=js&"
import style0 from "./RejectedRepairPartTable.vue?vue&type=style&index=0&id=028d6a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d6a2d",
  null
  
)

export default component.exports